import { createStore, type StoreHost } from '@nextcollage/engine';
import { loadTheme, loadTool } from './persistence';
import { removeAsset } from '@/media/assetStore';

/**
 * The browser's answers to the four questions the shared store cannot answer
 * for itself. Everything else about the store — the three documents, the undo
 * history, every action — lives in `@nextcollage/engine` and is identical on
 * a phone.
 */
const browser: StoreHost = {
  loadTheme,

  /**
   * The tool the entry page declares outranks the saved last-tool: somebody
   * arriving at /carousel from a search result must land in the carousel.
   * The attribute is deliberate rather than sniffing the pathname — nginx's
   * SPA fallback serves index.html for any unmatched path.
   */
  bootTool() {
    if (typeof document === 'undefined') return null;
    const declared = document.body?.dataset?.tool;
    if (declared === 'splitter' || declared === 'carousel' || declared === 'collage') {
      return declared;
    }
    return loadTool();
  },

  /**
   * Below the desktop breakpoint the side panels are overlay drawers, so they
   * start closed — opening both over a phone screen would bury the canvas.
   */
  panelsStartOpen() {
    if (typeof window === 'undefined') return true;
    return window.matchMedia('(min-width: 1024px)').matches;
  },

  dropAsset: removeAsset,
};

export const useStore = createStore(browser);

export { DOC_KEY, selectSelectedCells } from '@nextcollage/engine';
export type { DocKey, InspectorTab, Theme, Toast } from '@nextcollage/engine';
